import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { CircularProgress, Box } from '@mui/material'
import { useDispatch } from 'react-redux'

import { setIsAuthenticated } from '@store/slices/Authentication.slice'
import { setWithExpiry } from '@util/LocalStorage'

const SSOValidator: React.FC = () => {
    const navigate = useNavigate()
    const { hash } = useLocation()
    const dispatch = useDispatch()

    useEffect(() => {
        const tokenData = hash.split('#accessToken=')
        const token = tokenData?.[1]
        if (token) {
            setWithExpiry('token', token, 720 * 60 * 1000)
            dispatch(setIsAuthenticated(true))
            navigate('/dashboard', { replace: true })
        } else {
            dispatch(setIsAuthenticated(false))
            navigate('/login', { replace: true })
        }
    }, [hash])

    return (
        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress size={50} />
        </Box>
    )
}

export default SSOValidator
